/**
 * 2019/1/18
 * 作者:lzq
 *功能: 日志统计模块
 */
export default {
  $getway: 'sysapi',
  getDepartSelectAllDepartName: 'depart/selectAllDepartName',
  getOperationAelectALL: 'operation/selectAll',
  getOperateLogDepartHistogram: 'operateLog/departHistogram',
  getOperateLogDepartPie: 'operateLog/departPie'
};
